<template>
  <el-card class="balance-card" shadow="never">
    <div slot="header" class="clearfix">
      <i class="fas fa-donate"></i>
      {{ $t("ielts.Your T-Coin Balance") }}
    </div>
    <div class="body">
      <div class="balance text-center">
        <h6 class="info-tip">{{ $t("ielts.Balance") }}</h6>
        <h3 class="my-balance">{{ getProfile.point }}</h3>
        <span class="balance-name">{{ $t("ielts.T-Coins") }}</span>
      </div>
      <div class="addBalance text-center">
        <el-link href="/ielts/profile/balance">
          <el-button type="success">
            {{ $t("ielts.Get more T-Coins") }}
          </el-button>
        </el-link>
      </div>
    </div>
  </el-card>
</template>

<script>
/*eslint-disable no-unused-vars */
import { mapState, mapGetters, mapActions } from "vuex";
/*eslint-enable */

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("user", ["getProfile"])
  },
  watch: {},

  mounted() {},

  methods: {}
};
</script>

<style scoped>
.balance-card {
  height: 100%;
}
.info-tip {
  margin-top: 15px;
  margin-bottom: 13px;
  font-size: 14px;
  color: #99a2aa;
  letter-spacing: 0;
}
.my-balance {
  display: inline-block;
  font-size: 50px;
  color: var(--themeColor);
}
.addBalance {
  margin-top: 10px;
}
.balance-name {
  display: inline-block;
  font-size: 16px;
  margin-left: 4px;
  color: var(--themeColor);
}
</style>
